import { Component, OnInit, OnDestroy } from '@angular/core';
import {jwtDecode} from 'jwt-decode';
import { ActivatedRoute } from '@angular/router';
import { usuarioService } from 'src/app/services/SiicartAdm/usuarioAdm.service';
import { alertMessage } from 'src/app/models/SicarMap/Inicio/alertMessage.model';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {


    constructor(
    private route: ActivatedRoute,
    private userService: usuarioService,
    ){}

    password: string = '';
    lengthValid: boolean = false;
    letterValid: boolean = false;
    numberValid: boolean = false;
    specialCharValid: boolean = false;
    passwordConf: string = '';
    message: string = '';
    messageError: string = '';
    messageColor: string = 'red';
    token: string = '';
    usId: string = '';
    tokenValido: boolean | null = null; // `null` mientras se verifica
    isVisible: boolean = false;
    alertType: 'success' | 'error' = 'success';
    alertMessage: string = '';
    alertTitulo: string = '';
    


    ngOnInit(){
        this.token = this.route.snapshot.queryParamMap.get('token') || '';
        this.usId = this.route.snapshot.queryParamMap.get('us') || '';
        if(this.token && this.usId) {
            this.userService.validarToken(this.token).subscribe(response => {
                if(response['item1'] === false){
                    this.tokenValido = false;
                } else {
                    this.tokenValido = true;
                }
              }, error => {
                console.error( error);
              });
        } else {
            this.tokenValido = false;
        }
    }

    async changePass(){
        this.validatePassword();
        if (!this.lengthValid || !this.letterValid || !this.numberValid || !this.specialCharValid) {
            this.messageError = 'La contraseña no cumple con los requisitos';
            this.messageColor = 'red';
            this.message = '';
            return;
        }
    
        if(this.password === ''){
            this.messageError = 'Ingresa una contraseña';
            this.messageColor = 'red';
            this.message ='';
        } else {
            if(this.password === this.passwordConf){
                this.userService.updatePass(this.usId, this.password).subscribe(response => {
                    // console.log(response);
                    if(response['ok'] === true){
                        this.alertMessage = 'Vuelve a la página principal e inicia sesión';
                        this.alertTitulo = response['message'];
                        this.alertType = 'success';
                        this.isVisible = true;
                    } else {
                        this.alertMessage = 'Algo salió mal, intenta más tarde';
                        this.alertTitulo = response['message']
                        this.alertType = 'error';
                        this.isVisible = true;
                    }
                  }, error => {
                    console.error(error);
                    this.alertMessage = 'Algo salió mal, intenta más tarde';
                    this.alertTitulo = 'Advertencia'
                    this.alertType = 'error';
                    this.isVisible = true;
                  });
            } else {
                this.messageError = 'Las contraseñas no son iguales';
                this.messageColor = 'red';
                this.message ='';
            }
        }
    }

    validatePassword() {
        this.lengthValid = this.password.length >= 12;
        this.letterValid = /[a-zA-Z]/.test(this.password);
        this.numberValid = /\d/.test(this.password);
        this.specialCharValid = /[@$!%*?&]/.test(this.password);
    }

}
